import React from 'react';
import './ServicesBanner.css';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/cartSlice';
import { translations } from '../utils/translations';

const ServicesBanner = () => {
  const selectedLang = useSelector(selectLanguage) || { code: 'en' };
  const t = translations[selectedLang.code || 'en'] || translations.en;

  const serviceItems = [
    {
      id: 1,
      title: t.deliveryTitle,
      desc: t.deliveryDesc,
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="1" y="3" width="15" height="13" />
          <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
          <circle cx="5.5" cy="18.5" r="2.5" />
          <circle cx="18.5" cy="18.5" r="2.5" />
        </svg>
      )
    },
    {
      id: 2,
      title: t.customerServiceTitle,
      desc: t.customerServiceDesc,
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          <path d="M12 7v5l2 2" />
        </svg>
      )
    },
    {
      id: 3,
      title: t.guaranteeTitle,
      desc: t.guaranteeDesc,
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <polyline points="9 11 11 13 15 9" />
        </svg>
      )
    }
  ];

  return (
    <section className="services-banner-wrapper">
      <div className="services-banner-container">
        {serviceItems.map((item) => (
          <div key={item.id} className="service-banner-item">
            <div className="service-icon-outer-ring">
              <div className="service-icon-inner-circle">
                {item.icon}
              </div>
            </div>
            <h3 className="service-item-title">{item.title}</h3>
            <p className="service-item-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesBanner;
